import { ActionTree } from 'vuex';
import { RootState } from '@/models/states/root-state.model';
import { FiltersEventsRegional, FiltersEventsRegionalState } from '@/models/states/filters-state.model';

export const actions: ActionTree<FiltersEventsRegionalState, RootState> = {
  updateFilters({ commit }, payload: FiltersEventsRegional): any {
    commit('onUpdateFilters', payload);
  },
};
